module.exports = __webpack_public_path__ + "static/media/surfair-480p.24ede585.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/video/surfair-480p.mov
// module id = 507
// module chunks = 0